import React from 'react'
import { UseFormReturn } from 'react-hook-form';
import TextEditor from '../../../FormEditors/TextEditor';
import { VirtualMedicine } from '../../../../apis/virtual-medicines/types';

interface VirtualMedicineStrengthEditorProps {
  form: UseFormReturn<VirtualMedicine>;
}

const VirtualMedicineStrengthEditor = ({ form }: VirtualMedicineStrengthEditorProps) => {
  return <TextEditor label="Strength" control={form.control} name="strength" />;
};

export default VirtualMedicineStrengthEditor;
